import { useBookInfContext } from "components/context/bookInfContext";
import BkCalendar from "./bkCalendar";
import BookInfCard from "./bkInfCard";
// import BookInfCard from "./itembkInfCard";
import Button from "components/button/default";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useRef, useState, TouchEvent, useEffect } from "react";
import {
  alertControl,
  emailRegex,
  getDurationDate,
  modalControl,
  phoneRegex,
} from "util/commAction";
import { useAuthContext } from "components/context/authContext";
import { useMutation } from "@tanstack/react-query";
import { logChkApi } from "components/api/user";
import { resvRmApi } from "components/api/book";
import "./bookInf.scss";
import DefaultModal from "components/modal/default";
import ModalPayInnner from "./pay";

export default function BottomSheet() {
  const { viewPort } = useAuthContext();
  const {
    isSearch,
    bkStep,
    bookInf,
    terms,
    onBkStep,
    onBookInf,
    setIsSearch,
    calendarOpen,
    setCalendarOpen,
  } = useBookInfContext();
  const { t } = useTranslation();
  const { state } = useLocation();
  const navigate = useNavigate();

  const sheetRef = useRef<HTMLDivElement>(null); // BottomSheet ref
  const rmInfRef = useRef<HTMLDivElement>(null);
  const btnWrapRef = useRef<HTMLDivElement>(null);

  const startY = useRef(0);
  const startHeight = useRef(0);
  const endHeight = useRef(0);
  const [deltaY, setDeltaY] = useState(0);
  const [height, setHeight] = useState(0); // 초기 높이
  const [rmInfHeight, setRmInfHeight] = useState(0); //객실 정보 높이
  const [isOpen, setIsOpen] = useState(false); // background overflow hidden
  const [payModalOpen, setPayModalOpen] = useState(false); // 결제모달창 오픈

  const resvInfRef = useRef<null>(null);
  const rmResvNoRef = useRef(null);

  // START
  const handleTouchStart = (e: TouchEvent<HTMLButtonElement>) => {
    startY.current = e.touches[0].clientY;

    startHeight.current = height;
    if (isOpen && sheetRef.current) {
      endHeight.current = sheetRef.current.offsetHeight;
    }
    setIsOpen(true);
    setCalendarOpen("");
  };

  // MOVE
  const handleTouchMove = (e: TouchEvent<HTMLButtonElement>) => {
    const deltaY = e.touches[0].clientY - startY.current;
    setDeltaY(deltaY);
    setIsOpen(true);

    if (sheetRef.current) {
      const newHeight =
        deltaY < 0 ? startHeight.current - deltaY : endHeight.current - deltaY;
      sheetRef.current.style.height = newHeight + "px";
    }
  };

  // END
  const handleTouchEnd = (e: TouchEvent<HTMLButtonElement>) => {
    if (sheetRef.current) {
      const sheetFullHeight = startHeight.current + rmInfHeight + 20 + "px";

      // bottom full open
      if (deltaY < -50) {
        sheetRef.current.style.height = sheetFullHeight;
      }

      // bottom sheet open
      if (deltaY > -50 && deltaY < 0) {
        sheetRef.current.style.height = startHeight.current + "px";
        setIsOpen(false);
      }

      //bottom sheet close
      if (deltaY < 50 && deltaY > 0) {
        sheetRef.current.style.height = endHeight.current + "px";
        setCalendarOpen("");
      }

      // deltaY startHeight close
      if (deltaY > 50) {
        sheetRef.current.style.height = startHeight.current + "px";
        setIsOpen(false);
      }
    }
  };

  // const [isOpen, setIsOpen] = useState(false); //결제 결제 취소 모달창

  //객실 예약
  const bookMutation = useMutation({
    mutationFn: resvRmApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          const rmResvNo = data.rmResvNo;
          rmResvNoRef.current = rmResvNo;

          onBookInf({ rmResvNo });

          // 객실 결제 진행
          const popup = window.open(
            "",
            "popup",
            "width=500, height=700,"
          ) as Window;

          if (!!rmResvNo) {
            let param = localStorage.getItem("promCd")
              ? `${rmResvNo}/${localStorage.getItem("promCd")}`
              : `${rmResvNo}`;
            const url = `/app/view/pay/payRequest/${param}`;
            popup.location.href = url;

            //결제 완료 취소 모달창 오픈
            setPayModalOpen(true);
          }
          if (!rmResvNo) {
            alertControl({
              isOpen: true,
              inner: "예약을 다시 진행하여 주세요.",
            });
          }
        }

        if (code === -1) {
          alertControl({
            isOpen: true,
            inner: message + "/ 객실을 다시 선택하여 주세요",
            click: () => {
              // 객실 다시 선택
              onBkStep(1);
              setPayModalOpen(false);
              setIsSearch(true);
            },
          });
        }
      }
    },
  });

  // 예약하기
  const handleResv = () => {
    // 로그인 체크
    // const { status, data } = await logChkApi();
    // if (status.code === 0) {
    if (resvInfRef.current) {
      // bookMutation.mutate(resvInfRef.current);
      //예약하기
      // const {
      //   status: { code, message },
      //   data,
      // } = await resvRmApi(resvInfRef.current);

      // if (code === 0) {
      //   const rmResvNo = data.rmResvNo;
      //   rmResvNoRef.current = rmResvNo;
      const popup = window.open(
        "",
        "popup",
        "width=500, height=700,"
      ) as Window;

      resvRmApi(resvInfRef.current).then((res: any) => {
        const {
          status: { code, message },
          data,
        } = res;

        if (code === 0) {
          const rmResvNo = data.rmResvNo;
          rmResvNoRef.current = rmResvNo;

          onBookInf({ rmResvNo });

          // 객실 결제 진행

          if (!!rmResvNo) {
            let param = localStorage.getItem("promCd")
              ? `${rmResvNo}/${localStorage.getItem("promCd")}`
              : `${rmResvNo}`;
            const url = `/app/view/pay/payRequest/${param}`;
            // window.location.href = url;
            popup.location.href = url;

            // new Promise((resolve) => {
            //   setTimeout(() => {
            //     resolve("");
            //   }, 200);
            // }).then(() => {
            //   popup.location.href = url;
            // });

            //결제 완료 취소 모달창 오픈
            setPayModalOpen(true);
            setIsOpen(false);
          }
          if (!rmResvNo) {
            alertControl({
              isOpen: true,
              inner: "예약을 다시 진행하여 주세요.",
            });
          }
        }
        if (code === -1) {
          alertControl({
            isOpen: true,
            inner: message + "/ 객실을 다시 선택하여 주세요",
            click: () => {
              // 객실 다시 선택
              onBkStep(1);
              setPayModalOpen(false);
              setIsSearch(true);
            },
          });
        }
      });
    }

    // }
    // if (status.code !== 0) {
    //   alertControl({
    //     isOpen: true,
    //     inner: t("alr_login_required"),
    //   });
    // }
  };

  // NEXT

  const handleNext = async () => {
    if (!bookInf?.rmInf) {
      return alertControl({
        isOpen: true,
        inner: t("alr_msg_bk_rm"),
      });
    }

    setIsOpen(false);
    if (bkStep < 3) {
      onBkStep(bkStep + 1);

      return;
    }
    if (bkStep === 3) {
      /**
       * 예약 완료 Api
       * 입력 데이터 가져오기
       */

      //
      if (sheetRef.current) {
        const parentEl =
          sheetRef.current.parentElement?.parentElement?.querySelector(
            "div.insert-inf"
          ) as HTMLDivElement;

        const form = parentEl.querySelector("form") as HTMLFormElement;

        let inf = {} as any;

        if (form) {
          const formData = new FormData(form);
          for (const [key, value] of formData.entries()) {
            inf = {
              ...inf,
              [key]: value,
            };
          }
        }

        const { emlId_1, emlId_2, emlId_3, cstMblCntyCd, ...res } = inf;

        const userInf = {
          ...res,
          cstEml: emlId_1 + "@" + (emlId_2 || emlId_3),
          cstMblCntyCd: cstMblCntyCd.replace(/\([^)]*\)/g, ""),
        };

        // 이메일, 휴대폰 번호 정규식 체크
        if (!emailRegex.test(userInf.cstEml)) {
          alertControl({
            isOpen: true,
            inner: t("alr_reg_mail"),
          });
          return;
        }

        if (!phoneRegex.test(userInf.cstMblNo)) {
          alertControl({
            isOpen: true,
            inner: "정확한 형식의 휴대폰번호를 입력하여 주세요.",
          });
          return;
        }

        let isAllChecked = terms["01"] && terms["02"] && terms["03"];

        if (!isAllChecked) {
          return alertControl({
            isOpen: true,
            inner: t("alm_chk_info_bk"),
          });
        }

        const { dates, rmNo, rmTotCt, adltCnt, childCnt, opRgSeq, promCd } =
          bookInf;
        const bookInfo = {
          rmNo: rmNo,
          resvSDt: dates[0],
          resvEDt: dates[1],
          resvRmCt: rmTotCt,
          adltPerCt: adltCnt,
          chldPerCt: childCnt,
          babyPerCt: 0,
          opRgSeq: opRgSeq,
          promCd: promCd,
        };

        let params = {
          ...bookInfo,
          ...userInf,
        };

        resvInfRef.current = params;

        /*
         *  클릭 이벤트 내에서 팝업을 띄움 (팝업 차단 방지)
         */
        const eximbayPopup = window.open(
          "",
          "eximbayPopup",
          "width=500, height=700,"
        ) as Window;

        /**
         * 로그인 상태 체크
         */
        const {
          status: { code, message },
          data,
        } = await logChkApi();
        if (code !== 0) {
          eximbayPopup.close();
          return alertControl({
            isOpen: true,
            inner: "로그인을 진행하여 주세요.",
          });
        }

        // handleResv();
        /**
         * 예약진행하기
         */

        if (code === 0) {
          try {
            const {
              status: { code, message },
              data,
            } = await resvRmApi(params);
            if (code === 0) {
              const rmResvNo = data.rmResvNo;
              rmResvNoRef.current = rmResvNo;

              onBookInf({ rmResvNo });

              // 객실 결제 진행

              if (!!rmResvNo) {
                let param = localStorage.getItem("promCd")
                  ? `${rmResvNo}/${localStorage.getItem("promCd")}`
                  : `${rmResvNo}`;
                const url = `/app/view/pay/payRequest/${param}`;
                // window.location.href = url;
                eximbayPopup.location.href = url;

                // new Promise((resolve) => {
                //   setTimeout(() => {
                //     resolve("");
                //   }, 200);
                // }).then(() => {
                //   popup.location.href = url;
                // });

                //결제 완료 취소 모달창 오픈
                setPayModalOpen(true);
                setIsOpen(false);
              }
              if (!rmResvNo) {
                alertControl({
                  isOpen: true,
                  inner: "예약을 다시 진행하여 주세요.",
                });
              }
            }
            if (code === -1) {
              alertControl({
                isOpen: true,
                inner: message + "/ 객실을 다시 선택하여 주세요",
                click: () => {
                  // 객실 다시 선택
                  onBkStep(1);
                  setPayModalOpen(false);
                  setIsSearch(true);
                },
              });
            }
          } catch (error) {
            console.error("결제 URL 요청 실패", error);
            alertControl({
              isOpen: true,
              inner: "결제 요청에 실패하였습니다.",
            });
          }
        }

        // resvRmApi(params).then((res: any) => {
        //   const {
        //     status: { code, message },
        //     data,
        //   } = res;

        //   if (code === 0 && eximbayPopup) {
        //     const rmResvNo = data.rmResvNo;
        //     rmResvNoRef.current = rmResvNo;

        //     onBookInf({ rmResvNo });

        //     // 객실 결제 진행

        //     if (!!rmResvNo) {
        //       let param = localStorage.getItem("promCd")
        //         ? `${rmResvNo}/${localStorage.getItem("promCd")}`
        //         : `${rmResvNo}`;
        //       const url = `/app/view/pay/payRequest/${param}`;
        //       // window.location.href = url;
        //       eximbayPopup.location.href = url;

        //       // new Promise((resolve) => {
        //       //   setTimeout(() => {
        //       //     resolve("");
        //       //   }, 200);
        //       // }).then(() => {
        //       //   popup.location.href = url;
        //       // });

        //       //결제 완료 취소 모달창 오픈
        //       setPayModalOpen(true);
        //       setIsOpen(false);
        //     }
        //     if (!rmResvNo) {
        //       alertControl({
        //         isOpen: true,
        //         inner: "예약을 다시 진행하여 주세요.",
        //       });
        //     }
        //   }
        //   if (code === -1) {
        //     alertControl({
        //       isOpen: true,
        //       inner: message + "/ 객실을 다시 선택하여 주세요",
        //       click: () => {
        //         // 객실 다시 선택
        //         onBkStep(1);
        //         setPayModalOpen(false);
        //         setIsSearch(true);
        //       },
        //     });
        //   }
        // });

        // logChkMutation.mutate();

        return;
      }
    }
  };

  //초기높이 값 설정
  useEffect(() => {
    if (sheetRef.current && btnWrapRef.current) {
      const clientHeight = sheetRef.current.clientHeight;
      // const btnWrapHeight = btnWrapRef.current.clientHeight;
      setHeight(clientHeight);
    }
  }, []);

  // 날짜 선택 다시 검색 시
  useEffect(() => {
    if (sheetRef.current) {
      sheetRef.current.style.height = startHeight.current + "px";
      setIsOpen(false);
    }
  }, [isSearch]);

  //BOTTOM SHEET IS OPEN  BACKGROUND OVERFLOW HIDDEN
  const savedScrollY = useRef(0);

  useEffect(() => {
    if (isOpen) {
      if (rmInfRef.current) {
        setRmInfHeight(rmInfRef.current.offsetHeight);
      }
      savedScrollY.current = window.scrollY;
      document.body.classList.add("modal-open");
      document.body.classList.add("overscroll-y-contain");
      document.body.style.top = "-" + savedScrollY.current + "px";
    } else {
      document.body.classList.remove("modal-open");
      document.body.style.top = 0 + "px";
      document.body.classList.remove("overscroll-y-contain");
      window.scrollTo(0, savedScrollY.current);
    }
  }, [isOpen]);

  //CLICK CALENDAR BUTTON  BOTTOM SHEET OPEN
  useEffect(() => {
    if (sheetRef.current) {
      if (!!calendarOpen) {
        const clientHeight = sheetRef.current.clientHeight;
        const calendarEl = sheetRef.current.querySelector("div.calendar-op")
          ?.nextSibling as HTMLDivElement; // 달력 el

        const height = clientHeight + calendarEl?.clientHeight;
        sheetRef.current.style.height = height + "px";
        setIsOpen(true);
      }
      if (!calendarOpen) {
        sheetRef.current.style.height =
          startHeight.current + rmInfHeight + "px";
      }
    }
  }, [calendarOpen]);

  // PACKGE SELECTED OPEN BOTTOM SHEET
  useEffect(() => {
    if (bookInf?.rmInf && sheetRef.current && viewPort?.screen === "mb") {
      setIsOpen(true);

      //객실 선택 시  BOTTOM SHEET OPEN
      if (
        bookInf?.rmInf &&
        sheetRef.current &&
        bkStep === 1 &&
        viewPort?.screen === "mb"
      ) {
        sheetRef.current.style.height =
          startHeight.current + rmInfHeight + 110 + "px";
      }
    }
  }, [bookInf]);

  useEffect(() => {
    if (sheetRef.current) {
      sheetRef.current.style.height = height + "px";
    }
    window.scrollTo(0, savedScrollY.current);
  }, [bkStep]);

  const inf = {
    rmCnt: state?.rmCnt,
    adltCnt: state?.adltCnt,
    childCnt: state?.childCnt,
  };

  return (
    <>
      {bkStep !== 4 && (
        <div className={isOpen ? "modal-layout" : ""}>
          <div className="bottom-sheet" ref={sheetRef}>
            <button
              className="sheet-handle"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            />
            {/* 날짜선택 */}

            {isOpen && (
              <div ref={rmInfRef}>
                <div className="flex gap-2 mb-3">
                  <h3 className="sub">{t("bck_ttl_bk_inf")}</h3>
                  <h3 className="sub text-blue-300">
                    {getDurationDate(bookInf?.dates[0], bookInf?.dates[1])}
                  </h3>
                </div>

                <BkCalendar />

                {/* 객실 선택 정보 */}
                <BookInfCard isOpen={isOpen} inf={inf} />
              </div>
            )}
            <div className="sheet-btn-wrap " ref={btnWrapRef}>
              <Button
                text={""}
                styels="icon-prev"
                onClick={() => {
                  if (bkStep === 1) {
                    navigate(-1);
                    localStorage.removeItem("dates");
                    return;
                  }
                  if (bkStep !== 1) {
                    onBkStep(bkStep - 1);
                  }
                }}
              />
              <Button
                text={bkStep < 3 ? t("btn_nxt_bk") : t("sb_ttl_bk_cmplt")}
                styels="flex-1"
                onClick={handleNext}
              />
            </div>
          </div>
        </div>
      )}
      <DefaultModal
        isOpen={payModalOpen}
        btnTxt={""}
        styles="max-w-[380px]"
        handleClose={() => {
          setPayModalOpen(false);
        }}
      >
        <ModalPayInnner
          handleClose={() => {
            setPayModalOpen(false);
            setIsOpen(false);
          }}
        />
      </DefaultModal>
    </>
  );
}
